var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500.00001 500.00001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.0274 0 0 7.0274 74.315 -6969.7)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 1027.4,
    r: 23.151,
    fill: "none",
    stroke: "#555",
    strokeWidth: 2.0801
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 1002.4)",
    d: "m25.043 8.6289c-0.33906-0.016-0.65851 0.15913-0.82812 0.45312l-14.027 24.297c-0.34884 0.6047 0.08702 1.3604 0.78516 1.3613h28.055c0.69814-9e-4 1.134-0.75663 0.78516-1.3613l-14.027-24.297c-0.15424-0.2674-0.43382-0.43812-0.74219-0.45312zm-0.07031 8.3867c1.0132-0.0158 1.838 0.80701 1.8242 1.8203l-0.63477 8.0352c0.02221 1.5706-2.3464 1.5706-2.3242 0l-0.63477-8.0352c-0.0135-0.9913 0.77832-1.8053 1.7695-1.8203zm0.027341 12.318a1.1614 1.1614 0 0 1 1.1621 1.1621 1.1614 1.1614 0 0 1 -1.1621 1.1602 1.1614 1.1614 0 0 1 -1.1621 -1.1602 1.1614 1.1614 0 0 1 1.1621 -1.1621z",
    color: "#000000",
    colorRendering: "auto",
    fill: "#555",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textTransform: "none",
      whiteSpace: "normal"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.127d4b99ac3ad8f092ab000c5c00e0fd.svg";
export { ForwardRef as ReactComponent };